import store from '../redux/store';
import { setGlobalLoading } from '../redux/App/App.slice';

const ApiWrapper = (thunk: any, promise: boolean = false) => {
  store.dispatch(setGlobalLoading(true));
  return (promise ? thunk : store.dispatch(thunk)).finally(() => {
    store.dispatch(setGlobalLoading(false));
  });
};

export default ApiWrapper;
